import Text from "../../../Components/Text/Text";
import { ReactComponent as RightTriangleSvg } from "../../../assets/svgs/right-triangle.svg";
import BlockchainImage from "../../../assets/images/blockchain-image.png";
import { useRef } from "react";
import { useWindowScroll } from "../../../hooks/useWindowScroll";

export default function StrengthSection() {
  const ref = useRef();
  const { y, height } = useWindowScroll();

  const { offsetTop: elOffsetTop } = ref?.current || {};
  const boundary = elOffsetTop - height / 1.5;
  const show = y > boundary;

  return (
    <section
      ref={ref}
      className="relative pt-24 pb-52 bg-[#F4F4F4] overflow-hidden"
    >
      <div className="container mx-auto px-4 grid place-items-center gap-8 sm:grid-cols-2">
        <img
          src={BlockchainImage}
          alt="ead"
          className={`m-auto max-w-[450px] transition-all duration-700 ${
            show ? "" : "opacity-0 translate-x-96"
          }`}
        />
        <div
          className={`mx-auto transition-all duration-700 ${
            show ? "" : "opacity-0 translate-y-96"
          }`}
        >
          <Text type="p" size="lg" className="font-semibold my-4">
            What is Blockchain?
          </Text>
          <Text>
            A blockchain is a single version of a set of information that is
            immutable and secured with a time-stamped ledger. The different
            copies of that single version of information will be held by
            multiple users for verification.
          </Text>
        </div>
      </div>
      <RightTriangleSvg className="transition-all absolute bottom-0 fill-white animate-raise-up w-full" />
    </section>
  );
}
